import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {take} from 'rxjs/operators';
import {Store} from '~/app/core/common/models/store';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {ProfileCategoriesService} from '~/app/core/common/services/profile-categories.service';
import {KeycloakHelper} from '~/app/shared/helpers/keycloak-helper';
import {LoadingIndicatorHelper} from '~/app/shared/helpers/loading-indicator-helper';
import {ApplicationSettingsHelper} from '~/app/shared/helpers/application-settings-helper';
import {ConfirmationService} from '~/app/core/common/services/confirmation.service';
import {AuthServicesService} from 'mclane-webauth-lib';
import {ProfileService} from '~/app/core/common/services/profile.service';
import { DialogRef } from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-storelist-dialog',
    templateUrl: './storelist-dialog.component.html',
    styleUrls: ['./storelist-dialog.component.scss']
})
export class StorelistDialogComponent implements OnInit {
    @Input()
    title: string;
    @Input()
    type: string;
    @Input()
    public width = 0;
    @Input()
    public height = 0;
    message: string;
    categories: any[] = [];
    @Input()
    public opened = false;
    @Output()
    public closed = new EventEmitter<string>();

    constructor(private _keycloakHelper: KeycloakHelper,
                private _loadingIndicatorHelper: LoadingIndicatorHelper,
                public storeListService: StoreListService,
                public profileCategoriesService: ProfileCategoriesService,
                public profileService: ProfileService,
                public applicationSettingsHelper: ApplicationSettingsHelper,
                public confirmationService: ConfirmationService,
                public auth: AuthServicesService,
                ) {
        this.opened = false;
    }

    ngOnInit(): void {
    }

    public open(type: string,
                title: string,
                message: string,
                cancel: string,
                confirm: string,
                minWidth: number,
                width: number,
                minHeight: number,
                height: number,
                categories: any): Promise<any> {
        this.type = type;
        this.title = title;
        this.width = width;
        this.height = height;
        this.message = '';
        this.categories = categories;
        this.opened = true;
        return this.closed.asObservable()
            .pipe(take(1))
            .toPromise();
    }

    public close(store: any) {
        this.opened = false;
        if (store !== undefined) {
            this.updateAppStoreSection(store).then(() => {
            });
        }
        this.closed.emit(store);
    }

    public onClose(){
        this.opened = false;
    }

    async updateAppStoreSection(store: Store) {
        const username = this.auth.getUsername();
        this._loadingIndicatorHelper.show('');
        localStorage.setItem('store_selected', username.toUpperCase() + '-' + store.customerId);
        this.storeListService.pickedStore = store;
        await this.profileCategoriesService.getCustomerCategories();
        this.applicationSettingsHelper.setCustomerId(store.customerId.toString());
        this.confirmationService.getStoreConfirmation().then(r => r);
        this._loadingIndicatorHelper.hide();
        return store;
    }
}
